import { Component, Inject, ViewContainerRef, ViewChild, ElementRef } from '@angular/core';
import { ProductService } from '../../services/product/product.service';
import { Product } from '../../models/products/product.model';
import { SystemSettingService } from '../../services/system-settings/system-setting.service';
import { ImageProcessing } from '../../models/system-setting/ImageProcessing.model';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { Customer, VendorDropDown } from '../../models/customer/customer-model'
import { CustomerService } from '../../services/customer/customer.service';
import { BrandService } from '../../services/brand/brand.service';
import { Brand } from '../../models/brand/brand-model';
import { CategoryService } from '../../services/category/category.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { DisplayCategory } from '../../models/category/DisplayCategory.model';
import { EnumDropDown } from '../../models/shared/enum-dropdown';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css']
})
/** Product-List component*/
export class ProductListComponent {
  public ProductList: Product[] = []; 
  public ExportProductList: Product[];
  public ProductType: string;
  //Filter items from grid
  filteredItems: any[] = [];
  public vendorsList: VendorDropDown[] = [];
  public VendorLiveSearch: VendorDropDown[];
  public showSuggestionsLive: boolean = false;
  public brandList: Brand[] = [];
  public bulkChechUnCheck: any = false;
  public isLoaded: boolean = false;
  isFileDownload: boolean;
  public productStatus: EnumDropDown[];
  public bulkActionId: any;
  imageProcessing: ImageProcessing;
  public imageServerPath: string;
  public rowsPerPage: number;
  public pagenumber: number;
  public totalRecord: number;
  public arrRowsPerPage: number[] = [];
  public categoryList: DisplayCategory[] = [];
  public displayCategoryList: DisplayCategory[] = [];
  public parentCategoryID: number;
  public brandID: number;
  public productStatusId: number;
  public vendorID: string;
  public VID: number;
  public isActive: string;
  public isFeature: string;
  public inStock: string;
  public searchKeyword: string;
  pager: any = {};
  public showBoundaryLinks: boolean;
  public isDeleteAllowed: boolean = false;
  public isEditSimpleAllowed: boolean = false;
  public isEditVariableAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  @ViewChild('fileDownload') fileDownload: ElementRef;
  searchVendorName: string = "";
  /** Product-List ctor */
  constructor(private readonly SystemSettingService: SystemSettingService,
    private readonly brandsService: BrandService,
    private readonly categoryService: CategoryService,
    private readonly customerService: CustomerService,
    private readonly ProductService: ProductService,
    public toastr: ToastsManager,
    vcr: ViewContainerRef,
    private readonly utilitiesService: UtilitiesService, private readonly rolePermissionService: RolePermissionService, private readonly router: Router) {
    this.checkPermission();
    this.toastr.setRootViewContainerRef(vcr);
    this.brandID = 0;
    this.productStatusId = 0;
    this.vendorID = "";
    this.VID = 0;
    this.pagenumber = 0;
    this.showBoundaryLinks = true;
    this.getcustomers();
    this.GetProductStatus();
    this.isFileDownload = true;
    this.bulkActionId = "1"
    this.parentCategoryID = 0;
    this.totalRecord = 0;
    this.isActive = "";
    this.isFeature = "";
    this.inStock = "";
    this.searchKeyword = "";
    this.ProductType = "Recent";
    this.rowsPerPage = 10;
    // this.getImageServerPath();
   
    //  this.GetCategoryList();

  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("product").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "editsimple");
          });
          var editVariable = data.filter(function (element) {
            return (element.action == "editvariable");
          });
          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditSimpleAllowed = true;
          if (editVariable.length > 0)
            this.isEditVariableAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          }
          else {
            this.router.navigate(["/"]);
          }
          this.OnFilterChange();
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  LiveSearchVendor(searchText: string) {
    var length = 0;
    try {
      length = searchText.length;
    } catch (e) {
      return;
    }
    if (length > 0) {
      this.VendorLiveSearch = [];
      let regexp = new RegExp(searchText.toLowerCase());
      this.VendorLiveSearch = this.vendorsList.filter(x => x.shopeName.toLowerCase().match(regexp))
      this.showSuggestionsLive = true;
    }
    else {
      this.vendorID = "";
      this.VID = 0;
      this.VendorLiveSearch = this.vendorsList;
      this.searchVendorName = "";
      this.showSuggestionsLive = false;
      this.OnFilterChange();
    }
  }
  hide() {
    this.showSuggestionsLive = false;
  }
  SelectVendor(product: VendorDropDown) {
    this.searchVendorName = product.shopeName;
    this.vendorID = product.customerID.toString();
    this.VID = product.customerID;
    this.OnFilterChange();
    this.showSuggestionsLive = false;
  }
  clearVendors() {

    this.searchVendorName = "";
    this.vendorID = "";
    this.VID = 0;
    this.OnFilterChange();
  }
  deleteProduct(id) {
    this.ProductService.DeleteProduct(id);
    this.toastr.success('Product Status has been Changed Successfully ', 'Success');
    var index = this.ProductList.findIndex(x => x.id == id);
    if (index != -1) {
      var status = this.ProductList[index].isActive;
      this.ProductList[index].isActive = status == true ? false : true;
    }
  }
  selectionChanged(event: VendorDropDown) {
    try {
      this.vendorID = event.customerID.toString();
      this.VID = event.customerID;
    } catch (e) {

    }
    if (event === undefined) {
      this.vendorID = "";
      this.VID = 0;
    }
    this.OnFilterChange();
  }
  GetProductStatus() {
    this.ProductService.GetProductStatus().subscribe(
      data => {
        this.productStatus = data;
      }
    )
  }

  RemoveSelected() {
    if (this.searchVendorName != "") {
      this.searchVendorName = "";
      this.vendorID = "";
      this.VID = 0;
    }


  }
  BulkAction() {
    var ProductList = this.ProductList.filter(s => s.isCheck == true);
    if (ProductList.length <= 0) {
      this.toastr.info('Select any record to perform this option.', 'Info');
    }
    else {
      this.ProductService.UpdateProductStatusBulk(ProductList, this.bulkActionId).subscribe(
        data => {
          if (data) {
            this.toastr.success('Status has been updated.', 'Success');
            setTimeout(() => {
              this.OnFilterChangegrid();
            }, 500);
          }
          else {
            this.toastr.error('Error occurred. Oop!', 'Error');
          }
        }
      )
    }
  }
  BulkCheckUnCheked() {
    if (this.bulkChechUnCheck == false) {
      this.ProductList.forEach((item, index) => {
        this.ProductList[index].isCheck = true;//true ? false : true;  
      });
    }
    if (this.bulkChechUnCheck == true) {
      this.ProductList.forEach((item, index) => {
        this.ProductList[index].isCheck = false;//true ? false : true;  
      });
    }
  }
  getDispalyCategoryMenu() {
    if (this.categoryList.length === 0) {
      this.categoryService.GetAllCategoryList().subscribe(data => {
        this.categoryList = data;
        this.displayCategoryList = this.categoryList.filter(i => i.parentCategoryID === 0);
        this.displayCategoryList.forEach(element => {
          element.subCategory = this.categoryList.filter(i => i.parentCategoryID === element.categoryID);
          element.subCategory.forEach(child => {
            child.subCategory = this.categoryList.filter(i => i.parentCategoryID === child.categoryID);
          });
        });
      })
    }
  }

  getbrands() {
    if (this.brandList.length == 0) {
      this.brandsService.getBrand().subscribe(
        data => {
          this.brandList = data;
        }
      )
    }
  }
  getcustomers() {
    if (this.vendorsList.length == 0) {
      this.customerService.getVendorsDropDown().subscribe(
        data => {
          this.vendorsList = data;
          this.VendorLiveSearch = data;
        }
      )
    }
  }




  getImageServerPath() {
    this.SystemSettingService.GetImageServerPath().subscribe(
      data => {
        this.imageProcessing = data;
        this.imageServerPath = this.imageProcessing.path;
      });
  }


  PageChanged($event) {
    this.pagenumber = ($event.page) - 1;
    this.rowsPerPage = $event.itemsPerPage;

    this.OnFilterChangegrid();
  }

  OnFilterChange() {
    this.pagenumber = 0;
    this.OnFilterChangegrid();
  }

  OnFilterChangegrid() {
    var type: number = 0;
    if (this.parentCategoryID > 0) {
      var parent = this.categoryList.findIndex(role => role.categoryID == this.parentCategoryID && role.isParent === true && role.parentCategoryID === 0);
      var cat = this.categoryList.findIndex(role => role.categoryID == this.parentCategoryID && role.isParent === true && role.parentCategoryID > 0);
      var sub = this.categoryList.findIndex(role => role.categoryID == this.parentCategoryID && role.isParent === false && role.parentCategoryID > 0);

      if (parent > -1) {
        type = 0;
      }
      else if (cat > -1) {
        type = 1;
      }
      else {
        type = 2;
      }
    } else {
      type = 0;
    }

    if (this.rowsPerPage == undefined) this.rowsPerPage = 10;
    this.ProductService.GetAdminGridProducts(this.isActive, this.isFeature, this.inStock, this.parentCategoryID, type, this.brandID, this.productStatusId, this.VID, this.searchKeyword, this.pagenumber, this.rowsPerPage).subscribe(
      data => {
        this.isLoaded = true;
        this.ProductList = data;
        this.ProductList.forEach((item, index) => {
          if (this.ProductList[index].salePrice == 0) {
            this.ProductList[index].commissionAmount = this.ProductList[index].regularPrice - this.ProductList[index].commissionPrices;
          }
          else if (this.ProductList[index].salePrice > 0 && this.ProductList[index].salePrice > this.ProductList[index].regularPrice) {
            this.ProductList[index].commissionAmount = this.ProductList[index].regularPrice - this.ProductList[index].commissionPrices;
          }
          else if (this.ProductList[index].salePrice > 0 && this.ProductList[index].salePrice <= this.ProductList[index].regularPrice) {
            this.ProductList[index].commissionAmount = this.ProductList[index].salePrice - this.ProductList[index].commissionPrices;
          }
        });

        if (this.ProductList != null && this.ProductList.length > 0)
          this.totalRecord = this.ProductList[0].totalRecords;
        else
          this.totalRecord = 0;
        // this.filteredItems = data;
      }
    )
  }

  // Search the Grid
  onSearch(searchText: string) {
    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.ProductList, searchText);

    } else {
      this.filteredItems = this.ProductList;
    }
  }
  exportProducts() {
    if (this.isFileDownload) {
      this.isFileDownload = false;
      var type: number = 0;
      if (this.parentCategoryID > 0) {
        var parent = this.categoryList.findIndex(role => role.categoryID == this.parentCategoryID && role.isParent === true && role.parentCategoryID === 0);
        var cat = this.categoryList.findIndex(role => role.categoryID == this.parentCategoryID && role.isParent === true && role.parentCategoryID > 0);
        var sub = this.categoryList.findIndex(role => role.categoryID == this.parentCategoryID && role.isParent === false && role.parentCategoryID > 0);

        if (parent > -1) {
          type = 0;
        }
        else if (cat > -1) {
          type = 1;
        }
        else {
          type = 2;
        }
      } else {
        type = 0;
      }
      this.ProductService.GetExportProducts(this.isActive, this.isFeature, this.inStock, this.parentCategoryID, type, this.brandID, this.productStatusId, this.VID, this.searchKeyword).subscribe(
        data => {
          this.ExportProductList = data; 
          if (this.ExportProductList == null || this.ExportProductList.length <= 0) {
            this.toastr.info("No Products to Export", 'Info');
            this.isFileDownload = true;
          }
          else {
            this.ProductService.ExportProducts(this.ExportProductList).subscribe(
              data => {
                if (data.status == 1) {
                  var path = data.data;
                  this.fileDownload.nativeElement.href = "/Files/" + path;
                  this.fileDownload.nativeElement.click();
                  this.toastr.success(data.message, 'Success');
                  this.isFileDownload = true;
                }
                else {
                  this.toastr.error(data.message, 'Error');
                  this.isFileDownload = true;
                }
              })
          }
        }
      )

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/product-components/product-list/product-list.component.ts